var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',_vm._b({style:(_vm.computedTextStyles),attrs:{"show":_vm.computedShow},domProps:{"innerHTML":_vm._s(_vm.computedHtml)}},'b-alert',{ id: _vm.id, variant: _vm.variant },false))}
var staticRenderFns = []

export { render, staticRenderFns }